/* JPS Theme – Jarno's Part Service */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var scrim = $('[data-scrim]');

  /* ---------- drawers ---------- */
  function openPanel(el) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); });
    scrim.hidden = false; document.body.style.overflow = 'hidden';
  }
  function closePanels() {
    $$('.mmenu.is-open, .drawer.is-open').forEach(function (el) {
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
      if (el.hasAttribute('data-menu')) setTimeout(function () { el.hidden = true; }, 250);
    });
    scrim.hidden = true; document.body.style.overflow = '';
  }
  scrim.addEventListener('click', closePanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* mobiel menu buiten de sticky header plaatsen, zodat het boven de donkere laag ligt */
  (function () { var mm = document.querySelector('[data-menu]'); if (mm && mm.parentNode !== document.body) document.body.appendChild(mm); })();

  /* ---------- cart refresh ---------- */
  function refreshCart(open) {
    return Promise.all([
      fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch(root + 'cart.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var doc = new DOMParser().parseFromString(res[0]['cart-drawer'], 'text/html');
      var fresh = $('[data-drawer-inner]', doc), cur = $('[data-drawer-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = res[1].item_count; el.hidden = res[1].item_count === 0; });
      if (open) openPanel($('[data-drawer]'));
    });
  }

  /* ---------- sleep met de muis (categorieën) ---------- */
  (function () {
    $$('.cats, [data-drag]').forEach(function (tr) {
    var down = false, sx = 0, sl = 0, moved = false;
    tr.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = tr.scrollLeft; });
    window.addEventListener('mousemove', function (e) {
      if (!down) return; var dx = e.pageX - sx;
      if (Math.abs(dx) > 5) { moved = true; tr.classList.add('is-drag'); }
      if (moved) tr.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function () { if (!down) return; down = false; setTimeout(function () { tr.classList.remove('is-drag'); }, 0); });
    tr.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  })();



  /* ---------- categorieën wisselen automatisch ---------- */
  (function () {
    var tr = $('.cats'); if (!tr || window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var paused = false, visible = true, timer = null, wrap = tr.parentNode;
    function step() {
      if (paused || !visible || document.hidden) return;
      var max = tr.scrollWidth - tr.clientWidth;
      if (max <= 4) return;
      if (tr.scrollLeft >= max - 4) tr.scrollTo({ left: 0, behavior: 'smooth' });
      else tr.scrollBy({ left: tr.clientWidth + 14, behavior: 'smooth' });
    }
    function pause() { paused = true; }
    function resume() { paused = false; }
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (ev) { wrap.addEventListener(ev, pause, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { wrap.addEventListener(ev, resume); });
    wrap.addEventListener('touchend', function () { setTimeout(resume, 4000); }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(tr);
    timer = setInterval(step, 4000);
  })();

  /* ---------- typende voorbeelden in de zoekbalk ---------- */
  (function () {
    var inp = $('.hdr__search input[name="q"]'); if (!inp) return;
    var box = $('[data-psr]'), list = ((box && box.getAttribute('data-popular')) || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!list.length) list = ['Uitlaten', 'Cilinders', 'Kappensets', 'Carburateur', 'Remblokken', 'Variateur'];
    var base = inp.getAttribute('placeholder') || 'Zoek onderdeel of scooter';
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var i = 0, n = 0, dir = 1, timer = null, active = true;
    function stop() { active = false; clearTimeout(timer); inp.setAttribute('placeholder', base); }
    function tick() {
      if (!active) return;
      var w = list[i % list.length], d = 90;
      if (dir === 1) { n++; if (n >= w.length) { dir = -1; d = 1300; } }
      else { n--; d = 45; if (n <= 0) { dir = 1; i++; d = 350; } }
      inp.setAttribute('placeholder', 'Zoek ' + w.slice(0, Math.max(n, 0)) + '\u258F');
      timer = setTimeout(tick, d);
    }
    function start() { if (inp.value) return; active = true; n = 0; dir = 1; clearTimeout(timer); tick(); }
    inp.addEventListener('focus', stop);
    inp.addEventListener('blur', function () { if (!inp.value) start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else if (document.activeElement !== inp) { start(); } });
    start();
  })();

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-menu-open]'))) { openPanel($('[data-menu]')); return; }
    if (t.closest('[data-menu-close]') || t.closest('[data-cart-close]')) { closePanels(); return; }
    if ((el = t.closest('[data-cart-open]'))) {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault(); openPanel($('[data-drawer]')); return;
    }
    if ((el = t.closest('[data-quick-add]'))) {
      el.disabled = true; el.textContent = '…';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: +el.dataset.quickAdd, quantity: 1 }) })
        .then(function () { return refreshCart(false); });
      return;
    }
    if ((el = t.closest('[data-line][data-set]'))) {
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: +el.dataset.line, quantity: Math.max(0, +el.dataset.set) })
      }).then(function () { return refreshCart(false); });
      return;
    }
    if ((el = t.closest('[data-qty-step]'))) {
      var input = $('input', el.parentNode); if (!input) return;
      var v = (parseInt(input.value, 10) || 0) + (+el.dataset.qtyStep);
      input.value = Math.max(parseInt(input.min || '0', 10), v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if ((el = t.closest('[data-thumb]'))) { showMedia(el.dataset.thumb); return; }
    var tpl;
    if ((el = t.closest('[data-video-open]'))) {
      tpl = $('#vt-' + el.dataset.videoOpen); var dlg = $('[data-vdlg]'); if (!tpl || !dlg) return;
      var body = $('[data-vdlg-body]', dlg); body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true));
      if (dlg.showModal) dlg.showModal(); var vid = $('video', dlg); if (vid) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
      return;
    }
    if (t.closest('[data-vdlg-close]') || t.matches('[data-vdlg]')) { var d2 = $('[data-vdlg]'); if (d2 && d2.close) d2.close(); return; }
    if ((el = t.closest('[data-slide-dir]'))) {
      var tr = null, pn = el.parentNode; while (pn && !tr) { tr = $('[data-track]', pn); pn = pn.parentNode; }
      if (tr) tr.scrollBy({ left: +el.dataset.slideDir * tr.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    if ((el = t.closest('[data-cats-toggle]'))) {
      var ul = el.previousElementSibling, isOpen = ul.classList.toggle('is-open');
      el.textContent = isOpen ? 'Minder categorieën' : 'Toon alle categorieën'; return;
    }
    if (t.closest('[data-filter-toggle]')) {
      var fw = $('[data-filters-wrap]'); fw.classList.toggle('is-open');
      document.body.style.overflow = fw.classList.contains('is-open') ? 'hidden' : ''; return;
    }
  });

  document.addEventListener('close', function (e) { if (e.target.matches && e.target.matches('[data-vdlg]')) $('[data-vdlg-body]', e.target).innerHTML = ''; }, true);

  /* ---------- add to cart (ajax) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    var btn = $('[type=submit]', f), label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Toevoegen…'; }
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Toevoegen is niet gelukt.'); return; }
        return refreshCart(true);
      })
      .catch(function () { f.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  /* ---------- change events ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-cart-form] input[name="updates[]"]')) { t.form.requestSubmit(); return; }
    if (t.matches('[data-autosubmit]') || (t.closest('[data-filters]') && window.matchMedia('(min-width:990px)').matches)) {
      var form = t.form || t.closest('form'); if (form) form.requestSubmit(); return;
    }
    if (t.matches('[data-option]')) variantChange(t.closest('[data-buybox]'));
  });

  /* ---------- product: variants + gallery ---------- */
  function showMedia(id) {
    if (!id) return;
    var slide = $('[data-slide="' + id + '"]'); if (!slide) return;
    $$('[data-slide]').forEach(function (s) { s.classList.toggle('is-active', s === slide); });
    $$('[data-thumb]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.thumb === String(id)); });
    if (window.matchMedia('(max-width:989px)').matches && slide.parentNode) slide.parentNode.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  /* swipe-galerij: actieve thumb volgt het scrollen */
  var gTick = false;
  document.addEventListener('scroll', function (e) {
    var g = e.target; if (!g || !g.classList || !g.classList.contains('gallery__main') || gTick) return;
    gTick = true;
    requestAnimationFrame(function () {
      var slides = $$('[data-slide]', g), i = Math.round(g.scrollLeft / Math.max(g.clientWidth, 1)), cur = slides[i];
      if (cur) $$('[data-thumb]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.thumb === cur.dataset.slide); });
      gTick = false;
    });
  }, true);
  function variantChange(box) {
    if (!box) return;
    var section = box.closest('[data-section]');
    var variants = JSON.parse($('[data-variants]', section).textContent);
    var picked = $$('[data-option]:checked', box).sort(function (a, b) { return a.dataset.pos - b.dataset.pos; }).map(function (i) { return i.value; });
    var match = variants.filter(function (v) { return v.options.join('|') === picked.join('|'); })[0];
    if (!match) {
      var atc = $('[data-atc-main]', box); if (atc) { atc.disabled = true; atc.textContent = 'Niet beschikbaar'; }
      return;
    }
    history.replaceState(null, '', box.dataset.url + '?variant=' + match.id);
    fetch(box.dataset.url + '?variant=' + match.id + '&section_id=' + box.dataset.section)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-buybox]', doc);
        if (fresh) box.innerHTML = fresh.innerHTML;
        if (match.featured_media) showMedia(match.featured_media.id);
      });
  }

  /* sticky add-to-cart (mobile) */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var main = $('[data-atc-main]'), bar = $('[data-sticky]');
      if (main && bar) bar.classList.toggle('is-visible', main.getBoundingClientRect().bottom < 0);
      ticking = false;
    });
  }, { passive: true });

  /* ---------- product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    });
  });

  /* ---------- foto's bewegen mee met de muis ---------- */
  if (window.matchMedia('(hover:hover)').matches && !window.matchMedia('(prefers-reduced-motion:reduce)').matches) {
    document.addEventListener('pointermove', function (e) {
      var el = e.target.closest && e.target.closest('[data-tilt]'); if (!el) return;
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 2 - 1).toFixed(3));
      el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 2 - 1).toFixed(3));
    });
    document.addEventListener('pointerout', function (e) {
      var el = e.target.closest && e.target.closest('[data-tilt]');
      if (el && !el.contains(e.relatedTarget)) { el.style.setProperty('--mx', 0); el.style.setProperty('--my', 0); }
    });
  }

  /* ---------- aankondigingsbalk draait door op mobiel ---------- */
  var ann = $('[data-ann]');
  if (ann) {
    var msgs = $$('.ann__msg', ann), ai = 0, mq = window.matchMedia('(max-width:989px)');
    if (msgs.length > 1) {
      ann.classList.add('is-js');
      var paint = function () { msgs.forEach(function (m, k) { m.hidden = mq.matches && k !== ai; }); };
      paint(); setInterval(function () { ai = (ai + 1) % msgs.length; paint(); }, 4000);
      if (mq.addEventListener) mq.addEventListener('change', paint);
    }
  }

  /* ---------- header verdwijnt bij omlaag scrollen (mobiel) ---------- */
  var hw = document.querySelector('[id$="__header"]'), lastY = window.scrollY, hTick = false;
  if (hw) window.addEventListener('scroll', function () {
    if (hTick) return; hTick = true;
    requestAnimationFrame(function () {
      var y = window.scrollY, mob = window.matchMedia('(max-width:989px)').matches;
      if (mob && y > 200 && y > lastY + 6 && !hw.contains(document.activeElement)) hw.classList.add('is-hidden');
      else if (y < lastY - 6 || y <= 200 || !mob) hw.classList.remove('is-hidden');
      lastY = y; hTick = false;
    });
  }, { passive: true });

  /* ---------- zoeksuggesties ---------- */
  (function () {
    var form = $('.hdr__search'), input = form && $('input[type=search]', form), box = $('[data-psr]');
    if (!input || !box) return;
    var timer, ctrl, KEY = 'jps_recent_searches';
    function getRecent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function saveRecent(q) {
      q = q.trim(); if (!q) return;
      try { var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 5))); } catch (e) {}
    }
    function close() { box.hidden = true; box.textContent = ''; }
    function money(v) {
      try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(parseFloat(v)); }
      catch (e) { return v; }
    }
    function searchUrl(q) { return root + 'search?type=product&q=' + encodeURIComponent(q); }
    function heading(t) { var h = document.createElement('p'); h.className = 'psr__h'; h.textContent = t; box.appendChild(h); }
    function qLink(q) {
      var a = document.createElement('a'); a.className = 'psr__q'; a.href = searchUrl(q);
      a.textContent = q; return a;
    }
    function chips(list) {
      var w = document.createElement('div'); w.className = 'psr__chips';
      list.forEach(function (q) { w.appendChild(qLink(q)); }); box.appendChild(w);
    }
    function showStart() {
      box.textContent = '';
      var recent = getRecent(), pop = (box.dataset.popular || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      if (recent.length) { heading('Recent gezocht'); chips(recent); }
      if (pop.length) { heading('Populaire zoekopdrachten'); chips(pop); }
      box.hidden = !(recent.length || pop.length);
    }
    function render(res, q) {
      box.textContent = '';
      var queries = res.queries || [], cols = res.collections || [], prods = res.products || [];
      if (queries.length) {
        heading('Zoekopdrachten');
        queries.slice(0, 5).forEach(function (it) {
          var a = document.createElement('a'); a.className = 'psr__q psr__q--row'; a.href = it.url || searchUrl(it.text);
          a.textContent = it.text; box.appendChild(a);
        });
      }
      if (cols.length) {
        heading('Categorieën');
        var w = document.createElement('div'); w.className = 'psr__chips';
        cols.slice(0, 4).forEach(function (c) { var a = document.createElement('a'); a.className = 'psr__q'; a.href = c.url; a.textContent = c.title; w.appendChild(a); });
        box.appendChild(w);
      }
      if (prods.length) {
        heading('Producten');
        prods.forEach(function (it) {
          var a = document.createElement('a'); a.className = 'psr__item'; a.href = it.url;
          var im = document.createElement('img'); im.alt = ''; im.width = 52; im.height = 52; im.loading = 'lazy'; if (it.image) im.src = it.image;
          var t = document.createElement('span'); t.className = 'psr__t'; t.textContent = it.title;
          var pr = document.createElement('span'); pr.className = 'psr__p'; pr.textContent = money(it.price);
          a.appendChild(im); a.appendChild(t); a.appendChild(pr); box.appendChild(a);
        });
      }
      if (!queries.length && !cols.length && !prods.length) {
        var p = document.createElement('p'); p.className = 'psr__none'; p.textContent = 'Geen suggesties gevonden voor “' + q + '”. Druk op Enter om toch te zoeken.'; box.appendChild(p);
      }
      var all = document.createElement('a'); all.className = 'psr__all'; all.href = searchUrl(q);
      all.textContent = 'Alle resultaten voor “' + q + '” bekijken'; box.appendChild(all);
      box.hidden = false;
    }
    input.addEventListener('focus', function () { if (input.value.trim().length < 2) showStart(); });
    input.addEventListener('input', function () {
      clearTimeout(timer); var q = input.value.trim();
      if (q.length < 2) { if (ctrl) ctrl.abort(); showStart(); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=query,product,collection&resources[limit]=6&resources[limit_scope]=each' +
          '&resources[options][fields]=title,vendor,product_type,tag,variants.sku,variants.title', { signal: ctrl.signal })
          .then(function (r) { if (!r.ok) throw new Error('suggest'); return r.json(); })
          .then(function (j) { if (input.value.trim() === q) render((j.resources && j.resources.results) || {}, q); })
          .catch(function () {});
      }, 200);
    });
    form.addEventListener('submit', function () { saveRecent(input.value); });
    box.addEventListener('click', function (e) { var a = e.target.closest('.psr__q'); if (a) saveRecent(a.textContent); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowDown' && !box.hidden) { var f = $('a', box); if (f) { e.preventDefault(); f.focus(); } }
    });
    box.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = $$('a', box), i = links.indexOf(document.activeElement); if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowDown' && links[i + 1]) links[i + 1].focus();
      else if (e.key === 'ArrowUp') (i === 0 ? input : links[i - 1]).focus();
      if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.hdr__sw')) close(); });
  })();

})();
